import React from 'react'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faTriangleExclamation } from '@fortawesome/pro-solid-svg-icons'

import { GuideLink } from 'components/reusables/formInfoAlert'
import { DC3_CERTIFICATE_TEMPLATES_PATH } from 'config/dc3'
import { useTranslationRankmi } from 'helpers/translations.helper'

import {
  Banner,
  BannerBody,
  BannerContent,
  BannerIcon,
  BannerTitle,
} from './styled'

interface PublishedNormativeWithoutAttestationAlertProps {
  count: number
}

const PublishedNormativeWithoutAttestationAlert: React.FC<PublishedNormativeWithoutAttestationAlertProps> =
  ({ count }) => {
    const t = useTranslationRankmi({
      prefix: 'administration.courses.list.publishedWithoutAttestationAlert',
    })

    return (
      <Banner>
        <BannerIcon>
          <FontAwesomeIcon icon={faTriangleExclamation} aria-hidden />
        </BannerIcon>
        <BannerContent>
          <BannerTitle>
            {count === 1 ? t('title', { count }) : t('titlePlural', { count })}
          </BannerTitle>
          <BannerBody>
            {t('bodyBeforeLink')}
            <GuideLink href={DC3_CERTIFICATE_TEMPLATES_PATH}>
              {t('navigationLabel')}
            </GuideLink>
            {t('bodyAfterLink')}
          </BannerBody>
        </BannerContent>
      </Banner>
    )
  }

export default PublishedNormativeWithoutAttestationAlert
